export const studioConfig={publicUrl:location.origin,adminUrl:location.origin+'/admin/',partnerUrl:location.origin+'/partner/',environment:'staging'};
export function configureStudio(value:Partial<typeof studioConfig>){Object.assign(studioConfig,value);}
